import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function postDriverGroupsDriversUnassign(
  driverGroupId: number,
  unassignmentIds: string[]
) {
  return fromFetch(
    new Request(
      fleetEnvironment.driverGroupsDriversUnassignUrl(String(driverGroupId)),
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
        body: JSON.stringify({
          driverIds: unassignmentIds,
        }),
      }
    )
  ).pipe(ignoreData());
}
